<template>
  <el-col :sm="12">
    <div class="wrapper">
      <div class="header">
        <h2 class="">Toimipaikat</h2>
      </div>
      <div v-for="office in officesByDistrict">
        <office :office="office"></office>
      </div>
      <el-button class="add" type="primary" :plain="true" icon="plus" @click="addOffice"></el-button>
    </div>
  </el-col>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Office from './Office.vue';

  export default {
    components: { Office },

    computed: mapGetters(['officesByDistrict']),

    methods: {
      addOffice() {
        this.$store.commit('increment');
        const data = {
          values: {
            district: this.$store.getters.district,
            address: '',
            postal_code: '',
            post_office: '',
            webpage: '',
            phone: '',
            id: this.$store.getters.count,
            isNew: true,
          },
          type: 'offices',
        };
        this.$store.dispatch('addData', data);
      },
    },

  }
</script>

<style lang="scss" scoped>
  .wrapper {
    position: relative;
    .add {
      position: absolute;
      bottom: -17px;
      z-index: 100;
      left: calc(50% - 23px);
    } 
  }
  .header {
    margin-bottom: 20px;
    > * {
      display: inline-block;
      vertical-align: middle;
      margin: 0;
    }
  }
</style>




// WEBPACK FOOTER //
// Offices.vue?5167730a